import { formatCurrencyForLocale } from '@/event/locale'

export function getPrice(price: number) {
    return formatCurrencyForLocale(price)
}
